import { SpyneTrait } from "spyne";
import { UtilTraits } from "traits/util-traits";
import { PageDocsTraits } from "traits/page-docs-traits";
import { pick } from "ramda";

import TmplStage from "components/pages/templates/page-items/page-item-stage.tmpl.html";
import TmplSection from "components/pages/templates/page-items/page-item-section.tmpl.html";
import TmplTopic from "components/pages/templates/page-items/page-item-topic.tmpl.html";
import TmplSubtopic from "components/pages/templates/page-items/page-item-subtopic.tmpl.html";

import TmplBlockNutshell from "components/pages/templates/page-items/page-item-block-nutshell.html";
import TmplBlockHeading from "components/pages/templates/page-items/page-item-block-heading.html";
import TmplBlockWhatIsIt from "components/pages/templates/page-items/page-item-block-what-is-it.html";
import TmplBlockBody from "components/pages/templates/page-items/page-item-block-body.html";
import TmplBlockMultiList from "components/pages/templates/page-items/page-item-block-multi-list.html";
import TmplBlockList from "components/pages/templates/page-items/page-item-block-list.html";
import TmplBLockExternalItem from "components/pages/templates/page-items/page-item-block-external.html";
import TmplBlockCodeSample from "components/pages/templates/page-items/page-item-block-code-sample.html";
import TmplBlockCodeSampleBash from "components/pages/templates/page-items/page-item-block-code-sample-bash.html";
import TmplBlockclProse          from "components/pages/templates/claude/cl-prose.tmpl.html";
import TmplBlockclHeading        from "components/pages/templates/claude/cl-heading.tmpl.html";
import TmplBlockclLede           from "components/pages/templates/claude/cl-lede.tmpl.html";
import TmplBlockclList           from "components/pages/templates/claude/cl-list.tmpl.html";
import TmplBlockclDefinitionList from "components/pages/templates/claude/cl-definition-list.tmpl.html";
import TmplBlockclTable          from "components/pages/templates/claude/cl-table.tmpl.html";
import TmplBlockclCodeSample     from "components/pages/templates/claude/cl-code-sample.tmpl.html";
import TmplBlockclCallout        from "components/pages/templates/claude/cl-callout.tmpl.html";
import TmplBlockclAside          from "components/pages/templates/claude/cl-aside.tmpl.html";
import TmplBlockclSteps          from "components/pages/templates/claude/cl-steps.tmpl.html";
import TmplBlockclFigure         from "components/pages/templates/claude/cl-figure.tmpl.html";
import TmplBlockclExternal       from "components/pages/templates/claude/cl-external.tmpl.html";
import TmplBlockclCardGrid       from "components/pages/templates/claude/cl-card-grid.tmpl.html";
import TmplBlockclNote           from "components/pages/templates/claude/cl-note.tmpl.html";
import TmplBlockclProseLinks     from "components/pages/templates/claude/cl-prose-links.tmpl.html";


export class PageDocItemsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "pageDocItems$";

    super(context, traitPrefix);
  }

  static pageDocItems$GetItemTemplate(itemType = "topic") {
    const tmplHash = {
      stage: TmplStage,
      container: TmplSection,
      section: TmplSection,
      topic: TmplTopic,
      subtopic: TmplSubtopic,
      aside: TmplSubtopic,
    };

    return tmplHash[itemType];
  }

  static pageDocItems$CreateItemClass(props = this.props) {
    const { name, classVal } = props.data;
    const { pageId, itemType } = props.data.menuData;
    const itemName = name
      ? `-${UtilTraits.util$RemoveSpacesAndSpecialChars(name)}`
      : "";

    const itemTypeClean = UtilTraits.util$RemoveSpacesAndSpecialChars(itemType);

    return `docs-item docs-item-${itemType} ${pageId}-${itemTypeClean}${itemName} ${classVal}`;
  }

  static pageDocItems$CreateItemId(props = this.props) {
    const { name, itemId } = props.data;
    const { pageId, itemType } = props.data.menuData;
    const itemName = name ? `-${name}` : "";

    return ["stage", "section"].includes(itemType)
      ? `${pageId}-${itemType}${itemName}`
      : itemId;
  }

  static pageDocItems$GetItemBlockTemplate(blockType = "body") {
    const tmplHash = {
      nutshell: TmplBlockNutshell,
      heading: TmplBlockHeading,
      whatIsIt: TmplBlockWhatIsIt,
      body: TmplBlockBody,
      multiList: TmplBlockMultiList,
      list: TmplBlockList,
      external: TmplBLockExternalItem,
      codeSample: TmplBlockCodeSample,
      codeSampleBash: TmplBlockCodeSampleBash,
      clProse:            TmplBlockclProse,
      clHeading:          TmplBlockclHeading,
      clLede:             TmplBlockclLede,
      clList:             TmplBlockclList,
      clDefinitionList:   TmplBlockclDefinitionList,
      clTable:            TmplBlockclTable,
      clCodeSample:       TmplBlockclCodeSample,
      clCallout:          TmplBlockclCallout,
      clAside:            TmplBlockclAside,
      clSteps:            TmplBlockclSteps,
      clFigure:           TmplBlockclFigure,
      clExternal:         TmplBlockclExternal,
      clCardGrid:         TmplBlockclCardGrid,
      clNote:             TmplBlockclNote,
      clProseLinks:       TmplBlockclProseLinks,

    };

    return tmplHash[blockType];
  }

  static pageDocItems$CreateDataset(props = this.props) {
    const itemId = props?.data?.itemId;
    const levelsArr = PageDocsTraits.pageDocs$GetDocLevelsArray();

    const obj = pick(levelsArr, props?.data?.menuData);
    return { ...obj, itemId };
  }
  static pageDocItems$HelloWorld() {
    return "Hello World";
  }
}
